import { render, staticRenderFns } from "./TrucksList.vue?vue&type=template&id=69adcf49&scoped=true"
import script from "./TrucksList.vue?vue&type=script&lang=js"
export * from "./TrucksList.vue?vue&type=script&lang=js"
import style0 from "./TrucksList.vue?vue&type=style&index=0&id=69adcf49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69adcf49",
  null
  
)

export default component.exports